"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeolocationWithoutStyles = exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

var _FormControl = _interopRequireDefault(require("../FormControl/FormControl"));

var _ErrorHandlingFormHelperText = _interopRequireDefault(require("../ErrorHandlingFormHelperText/ErrorHandlingFormHelperText"));

var _GeolocationGoogleMapsHelper = require("./GeolocationGoogleMapsHelper");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Validations = _interopRequireWildcard(require("../Validations"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _styles2 = require("./styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var EnhancedTextInput = (0, _Validations.default)(_TextInput.default);

var Geolocation = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Geolocation, _Component);

  var _super = _createSuper(Geolocation);

  function Geolocation(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Geolocation);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "defaultState", function () {
      return {
        location: {
          address1: "",
          address2: "",
          city: "",
          state: "",
          zip: "",
          latitude: null,
          longitude: null
        },
        mapUrl: "",
        search: ""
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function () {
      _this.setState(function (prevState) {
        return {
          location: _objectSpread(_objectSpread({}, prevState.location), _this.props.value)
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "injectScript", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.props.googleMapsKey) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (_this.googleMapsHelper.shouldLoadMapsSdk(_this.props.googleMapsKey)) {
                _this.googleMapsHelper.loadMapsSdk(_this.props.googleMapsKey);
              }

              _context.next = 5;
              return _this.googleMapsHelper.loadPromise;

            case 5:
              _context.next = 7;
              return _this.googleMapsHelper.registerAddressSearch("".concat(_this.props.id, "-search"), _this.onAddressSearchSelected);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAddressSearchSelected", function () {
      var place = _this.googleMapsHelper.addressSearch.getPlace();

      if (!place || !place.geometry) return;

      var parsed = _this.parseAddress(place);

      var name = place.name ? "".concat(place.name, ", ") : "";

      _this.setState({
        search: "".concat(name).concat(place.formatted_address),
        location: _objectSpread({}, parsed),
        mapUrl: place.url
      }, function () {
        _this.props.onChange && _this.props.onChange(_this.state.location);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClear", function () {
      _this.setState(_this.defaultState(), function () {
        _this.props.onChange && _this.props.onChange(_this.state.location);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnChange", function (event, field) {
      var newState = _objectSpread(_objectSpread({}, _this.state.location), {}, (0, _defineProperty2.default)({}, field, event.target.value)); //If all the inputs are cleared, reset the local state to default.


      if (!newState.address1 && !newState.address2 && !newState.city && !newState.state && !newState.zip) {
        return _this.onClear();
      }

      _this.setState({
        location: newState
      }, function () {
        _this.props.onChange && _this.props.onChange(_this.state.location);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "parseAddress", function (value) {
      var getAddressValue = function getAddressValue(value) {
        return !value ? "" : value.short_name;
      };

      var latitude = value.geometry.location.lat();
      var longitude = value.geometry.location.lng();
      var address1 = getAddressValue(value.address_components.find(function (a) {
        return a.types.indexOf("street_number") > -1;
      })) + " " + getAddressValue(value.address_components.find(function (a) {
        return a.types.indexOf("route") > -1;
      }));
      address1 = address1.trim();
      var address2 = getAddressValue(value.address_components.find(function (a) {
        return a.types.indexOf("subpremise") > -1;
      }));
      var city = getAddressValue(value.address_components.find(function (a) {
        return a.types.indexOf("locality") > -1;
      }));
      var state = getAddressValue(value.address_components.find(function (a) {
        return a.types.indexOf("administrative_area_level_1") > -1;
      })).toUpperCase();
      var zipCode = getAddressValue(value.address_components.find(function (a) {
        return a.types.indexOf("postal_code") > -1;
      }));
      var zipCodeSuffix = getAddressValue(value.address_components.find(function (a) {
        return a.types.indexOf("postal_code_suffix") > -1;
      }));
      var zip = zipCodeSuffix === "" ? zipCode : zipCode + "-" + zipCodeSuffix;
      return {
        latitude: latitude,
        longitude: longitude,
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        zip: zip
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          disabled = _this$props.disabled,
          editor = _this$props.editor,
          label = _this$props.label,
          errorMessage = _this$props.errorMessage,
          fields = _this$props.fields,
          helperText = _this$props.helperText,
          required = _this$props.required,
          className = _this$props.className,
          onlyValidateOnBlur = _this$props.onlyValidateOnBlur,
          statePattern = _this$props.statePattern,
          statePatternMessage = _this$props.statePatternMessage,
          zipCodePattern = _this$props.zipCodePattern,
          zipCodePatternMessage = _this$props.zipCodePatternMessage,
          classes = _this$props.classes;
      /**
       * If there are child components that need to be validated, use `childComponentValidation`, this validator
       * will validate all child components and return those results in an array if there is a failure, otherwise it will
       * return `true` and allow the parent component to run other validators.
       */

      var error = Array.isArray(_this.props.error) && _this.props.error.length > 0 ? false : _this.props.error;
      return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        id: id,
        error: error,
        required: required,
        className: (0, _classnames.default)("prmbl-geolocation", className, classes.root),
        fullWidth: true
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 1
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        className: (0, _classnames.default)("prmbl-location-label", classes.locationLabel),
        id: "".concat(id)
      }, label)), _this.props.googleMapsKey && editor === "Map" && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          margin: ".5rem 0 .25rem"
        }
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        className: "prmbl-geolocation-search",
        fullWidth: true,
        disabled: disabled,
        label: "Search Google Maps",
        id: "".concat(id, "-search"),
        value: _this.state.search,
        onChange: function onChange(e) {
          _this.setState({
            search: e.target.value
          });
        },
        helperText: _this.state.mapUrl ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          href: _this.state.mapUrl
        }, "View Map")) : ""
      }))), fields.showAddress1 && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          margin: ".25rem 0"
        }
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        className: "prmbl-geolocation-address1",
        fullWidth: true,
        disabled: disabled,
        label: "Address 1",
        id: "".concat(id, "-address1"),
        value: _this.state.location.address1,
        onChange: function onChange(e) {
          return _this.handleOnChange(e, "address1");
        },
        error: error
      }))), fields.showAddress2 && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          margin: ".25rem 0"
        }
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        className: "prmbl-geolocation-address2",
        fullWidth: true,
        disabled: disabled,
        label: "Address 2",
        id: "".concat(id, "-address2"),
        value: _this.state.location.address2,
        error: error,
        onChange: function onChange(e) {
          return _this.handleOnChange(e, "address2");
        }
      }))), fields.showCity && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 7
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          margin: ".25rem 0 .5rem"
        }
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        className: "prmbl-geolocation-city",
        fullWidth: true,
        disabled: disabled,
        label: "City",
        id: "".concat(id, "-city"),
        value: _this.state.location.city,
        error: error,
        onChange: function onChange(e) {
          return _this.handleOnChange(e, "city");
        }
      }))), fields.showState && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 2
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          margin: ".25rem 0 .5rem"
        }
      }, /*#__PURE__*/_react.default.createElement(EnhancedTextInput, {
        className: "prmbl-geolocation-state",
        fullWidth: true,
        disabled: disabled,
        label: "State",
        id: "".concat(id, "-state"),
        value: _this.state.location.state,
        error: error,
        onlyValidateOnBlur: onlyValidateOnBlur,
        onChange: function onChange(e) {
          return _this.handleOnChange(e, "state");
        },
        ref: _this.stateComponentRef,
        regExpPattern: statePattern,
        errorMessages: {
          regExpPattern: statePatternMessage
        },
        validations: [_Validations.regExpValidation]
      }))), fields.showZipCode && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 3
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          margin: ".25rem 0 .5rem"
        }
      }, /*#__PURE__*/_react.default.createElement(EnhancedTextInput, {
        className: "prmbl-geolocation-zipcode",
        fullWidth: true,
        disabled: disabled,
        label: "ZIP Code",
        id: "".concat(id, "-zip"),
        value: _this.state.location.zip,
        error: error,
        onlyValidateOnBlur: onlyValidateOnBlur,
        onChange: function onChange(e) {
          return _this.handleOnChange(e, "zip");
        },
        ref: _this.zipCodeComponentRef,
        regExpPattern: zipCodePattern,
        errorMessages: {
          regExpPattern: zipCodePatternMessage
        },
        validations: [_Validations.regExpValidation]
      }))), !disabled && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        id: "".concat(id, "-geolocation-clear"),
        color: "default",
        onClick: _this.onClear,
        variant: "outlined"
      }, "Clear Address"))), /*#__PURE__*/_react.default.createElement(_ErrorHandlingFormHelperText.default, {
        id: "".concat(id, "-error-handler-text"),
        helperText: helperText,
        error: error,
        errorMessage: errorMessage
      }));
    });
    _this.state = _this.defaultState();
    _this.googleMapsHelper = _this.props.googleMapsHelper || new _GeolocationGoogleMapsHelper.GeolocationGoogleMapsHelper();
    _this.stateComponentRef = /*#__PURE__*/_react.default.createRef();
    _this.zipCodeComponentRef = /*#__PURE__*/_react.default.createRef();
    _this.childComponents = [];

    if (_this.props.fields.showState) {
      _this.childComponents.push(_this.stateComponentRef);
    }

    if (_this.props.fields.showZipCode) {
      _this.childComponents.push(_this.zipCodeComponentRef);
    }

    return _this;
  }

  (0, _createClass2.default)(Geolocation, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.init();
                this.injectScript();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(prevProps, prevState) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
                  this.init();
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidUpdate(_x, _x2) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }]);
  return Geolocation;
}(_react.Component);

exports.GeolocationWithoutStyles = Geolocation;
(0, _defineProperty2.default)(Geolocation, "propTypes", {
  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * Renders the component as disabled
   */
  disabled: _propTypes.default.bool,

  /**
   *  This now supports two types of error results. If the type is `object`
   *  then child component validations have failed, otherwise we return a `bool`
   * 	For the child component validation, this is supported by the following `childComponentValidation`
   */
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.array]),

  /**
   * The message to display when `error` is `true`.
   */
  errorMessage: _propTypes.default.string,

  /**
   * Determines what properties should be visible.
   */
  fields: _propTypes.default.shape({
    showAddress1: _propTypes.default.bool,
    showAddress2: _propTypes.default.bool,
    showCity: _propTypes.default.bool,
    showState: _propTypes.default.bool,
    showZipCode: _propTypes.default.bool
  }),

  /**
   * The contents of the `helper text`
   */
  helperText: _propTypes.default.node,

  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The label for the geolocation field
   */
  editor: _propTypes.default.string,

  /**
   * @ignore
   *
   * Gives the ability to inject the helper for testing purposes and different implementations.
   */
  googleMapsHelper: _propTypes.default.object,

  /**
   * The google maps api key.
   */
  googleMapsKey: _propTypes.default.string,

  /**
   * The label used for the component.
   */
  label: _propTypes.default.string,

  /**
   * onChange function called when address fields change.
   * latitude and longitude will be null if no google search was done since these two fields
   * can not be filled out by the user.
   * signature: ({
  		address1: string,
  		address2: string,
  		city: string,
  		state: string,
  		zip: string,
  		latitude: decimal?,
  		longitude: decimal?
  	}) => void
   */
  onChange: _propTypes.default.func,

  /**
   * Enforces the validation to trigger on blur, not on load.
   */
  onlyValidateOnBlur: _propTypes.default.bool,

  /**
   * If `true` the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * State regular expression value to be used.
   */
  statePattern: _propTypes.default.string,

  /**
   * State regular expression pattern message to be used.
   */
  statePatternMessage: _propTypes.default.string,

  /**
   * Pass through to override the initial value of the input fields.
   * This will only be set once.
   */
  value: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    zip: _propTypes.default.string,
    latitude: _propTypes.default.number,
    longitude: _propTypes.default.number
  }),

  /**
   * ZipCode regular expression value to be used.
   */
  zipCodePattern: _propTypes.default.string,

  /**
   * ZipCode regular expression message to be used.
   */
  zipCodePatternMessage: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object
});
(0, _defineProperty2.default)(Geolocation, "defaultProps", {
  className: "",
  fields: {
    showAddress1: true,
    showAddress2: true,
    showCity: true,
    showState: true,
    showZipCode: true
  },
  editor: "Map",
  onlyValidateOnBlur: false,
  classes: {
    root: {}
  }
});

var _default = (0, _styles.withStyles)(_styles2.styles)(Geolocation);

exports.default = _default;